import { render } from "./EditInventoryStatusPage.vue?vue&type=template&id=22e5af96"
import script from "./EditInventoryStatusPage.vue?vue&type=script&lang=js"
export * from "./EditInventoryStatusPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__